import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IZigZagCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class ZigZagCredentialsStore implements ICredentialsStore {
    private _changes: IZigZagCredentialsModel = {} as IZigZagCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get username() { return this._changes.username; };
    public get password() { return this._changes.password; };
    public get accountNumber() { return this._changes.account_number; };

    setUsername(value: string) {
        this._changes.username = value;
    };

    setPassword(value: string) {
        this._changes.password = value;
    };

    setAccountNumber(value: string) {
        this._changes.account_number = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default ZigZagCredentialsStore;
